module.exports = __webpack_public_path__ + "img/digital_io.28274f4d.svg";